// Side-effect module: starts `GET /auth/config` at module-evaluation time.
// Imported first in `main.tsx` so the request overlaps evaluation of the rest
// of the entry bundle. Kept separate from `./bootConfigFetch` so importing the
// helpers (from tests or components) never triggers a network call.
import { startAuthConfigPrefetch } from './bootConfigFetch';

startAuthConfigPrefetch();
